/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function e(){return[1,0,0,1,0,0]}function r(e){return[e[0],e[1],e[2],e[3],e[4],e[5]]}function t(e,r,t,n,o,a){return[e,r,t,n,o,a]}function n(e,r){return new Float64Array(e,r,6)}const o=Object.freeze(Object.defineProperty({__proto__:null,clone:r,create:e,createView:n,fromValues:t},Symbol.toStringTag,{value:"Module"}));export{r as a,n as b,e as c,t as f,o as m};
